import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import List from "./list";
import Disclaimer from "./disclaimer";
import httpService from "core/infrastructure/http";
import { IdAllocationConstraintDto, GetIdAllocationConstraintQuery, GetIdAllocationConstraintResponse } from "core/backend/data";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"; //fontawesome.com
import { PageList } from "core/pages/pageList";
const s = require("../../../../components/downloadButton.module.scss");

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "idAllocationConstraint";

export const page_config: PageList =
{
    apiUrl: "idAllocationConstraint",
    webUrl: "CCR_idAllocationConstraint",
    menu: "ibwt_common:menuIdAllocationConstraint",
    title: "ibwt_common:titleIdAllocationConstraint",
    apiType: "data",
    response: JSON.stringify(keys<GetIdAllocationConstraintResponse>()),
    dto: JSON.stringify(keys<IdAllocationConstraintDto>()),
    parameters: JSON.stringify(keys<GetIdAllocationConstraintQuery>()),
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};
type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {
    const initialData: IdAllocationConstraintDto[] = [];
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, keys<IdAllocationConstraintDto>());
            setLoading(true);
            setData([]);
            const response = await httpService.apiPost<GetIdAllocationConstraintResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,
                query: {
                    FromUtc: applicationState.getRootUtcTime().toISOString(),
                    ToUtc: applicationState.getUntilFor1Day().toISOString()
                },
                senderId: senderId
            })();

            if (response.ok) {
                setData(response.data.data);
                setError("");
            } else {
                setError(response.error || t("common:UnknownError"));
            }
            setLoading(false);
        })();
    }, [applicationState.selectedDate]);

    return (
        <>
            <SheetHeader showDownload={true} applicationState={applicationState} title={t(page_config.title)} senderId={senderId} pageConfig={page_config}y>
                <a href="/app/downloads/Cross-dependence between the level of the allocation constraint and the published parameters.pdf" target="_blank" style={{ float: "right", margin: "2rem", color: "#88a4bf", textDecoration: "underline" }}>
                    Explanatory note <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: "30px", verticalAlign: "middle", margin: "-6px 6px 0 6px" }} />
                </a>
            </SheetHeader>
            <Disclaimer data={data} />
            <SheetDataPart isLoading={isLoading} data={data} error={error}>
                <List data={data} />
            </SheetDataPart>
        </>
    );
};

export default withTranslation()(Page);
